import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Language (props) {

    const language = props.language,
        setLanguage = props.setLanguage

    useEffect(() => {})

    return (
        <div className="general_field">
            <legend>Which <strong>language(s)</strong> do you mostly speak every day?</legend>
            <div className="general_options">
                <input
                    type="text"
                    name="language" 
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    maxLength={30}
                    placeholder="Type something..."
                />
                <label style={{marginTop: '0.5em'}}>
                    <input 
                        type="radio" 
                        name="language" 
                        value="no_answer"
                        checked={language === "no_answer"}
                        onChange={() => setLanguage("no_answer")}
                        />
                    I prefer not to answer.
                </label>
            </div>
        </div>
    )
}

export default Language;